<template>
  <div>
        <v-layout wrap align-center justify-center class="px-2">
            <v-flex xs12 class="pb-2">
                <div class="subheading secondary--text">
                    <h4>{{ $t("enrollment.steps.login.component.title") }}</h4>
                </div>
            </v-flex>
            <v-flex xs12 mb-3>
                <v-form ref="emailForm" onsubmit="return false;">
                    <v-text-field
                        outline
                        id="email"
                        color="secondary"
                        background-color='secondary'
                        :label="$t('rms.field.email.label')"
                        name="email"
                        placeholder="example@mail.com"
                        :rules="[rules.required, rules.email]"
                        prepend-inner-icon="email"
                        type="text"
                        v-model="email"
                    ></v-text-field>
                    <v-layout row wrap align-center class="mt-3 mb-2" style="flex-wrap: nowrap">
                        <v-flex xs-auto class="d-flex align-center" style="padding-left: 10px">
                          <v-switch
                            class="terms-switch"
                            v-model="acceptTerms"
                            color="green"
                            hide-details
                            label=""
                            :rules="[rules.required]"
                          ></v-switch>
                        </v-flex>
                        <v-flex xs-fill style="padding-left: 10px">
                          <div class="terms-text" v-html="termsLabel" style="line-height: 1.3"></div>
                        </v-flex>
                      </v-layout>                      
                </v-form>
                <SocialLogin @onSuccess="onSuccessfullLogin"></SocialLogin>
            </v-flex>
        </v-layout>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                :class="[$vuetify.rtl ? 'ml-2' : '']"
                color="green white--text"
                @click.stop="onCancel"
                >{{ $t(`${eventPrefix}.btn.cancel`) }}</v-btn
            >
            <v-btn
                :class="[$vuetify.rtl ? 'mx-0' : '']"
                color="green white--text"
                @click.prevent="onConfirm"
                >{{ $t("enrollment.steps.continue.button") }}</v-btn
            >

        </v-card-actions>
  </div>
</template>

<script>
import { mapState } from "vuex";
import rules from "@/validation";
import SocialLogin from "@/components/auth/SocialLogin"
import DEFINES from "@/defines";

export default {
    name:"EnrollmentAskEmail",
    props:{
        eventPrefix: {
            type: String,
            default: 'screener'
        }
    },
    data(){
        return{
            rules,
            email:null,
            acceptTerms: false
        }
    },
    computed: {
        ...mapState({
            company: state => state.company.company,
        }),
        termsLabel() {
            const isNetfestOrAsincronie = 
                this.company.id === DEFINES.NETFEST_VOD_COMPANY_ID || 
                this.company.id === DEFINES.ASINCRONIE_VOD_COMPANY_ID;

            const termsLink = isNetfestOrAsincronie ? '/Terms-of-Use' : '/terms';
            const privacyLink = isNetfestOrAsincronie ? '/Privacy-Policy' : '/privacy';

            const target = isNetfestOrAsincronie ? '_self' : '_blank';

            const termsAnchor = `<a href='${termsLink}' target='${target}'>${this.$t('login_temrs_conditions')}</a>`;
            const privacyAnchor = `<a href='${privacyLink}' target='${target}'>${this.$t('login_privacy_policy')}</a>`;

            return this.$t('login_terms_privacy', {
                terms: termsAnchor,
                privacy: privacyAnchor,
            });
        }
    },
    components: {
        SocialLogin
    },
    watch:{
        email(){
            this.$emit("update:email",this.email);
        }
    },
    methods:{
        onCancel(){
            this.$emit("onCancel",{});
        },
        onConfirm(){
            this.$emit("onConfirm",{});
        },
        validate(){
            return this.$refs.emailForm.validate();
        },
        onSuccessfullLogin(response){
            this.$emit('loginWithFirebase',response)
        }
    }
}
</script>

<style scoped>
    >>> .v-text-field__slot input {
      color: var(--v-secondary-base) !important
    }
    >>> .v-icon {
        color: var(--v-secondary-base) !important
    }
    >>> .v-input__slot .v-label {
        color: var(--v-secondary-base) !important
    }
    .terms-switch.v-input.v-input--selection-controls {
        margin-top: 0 !important;
      }
</style>
